"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RTL 2021 API (2025.08.18.)
 * RTL 2021 API (2025.08.18.)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rtlteam@konzorcia.hu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEVELOPMENTONLYApi = void 0;
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class DEVELOPMENTONLYApi extends runtime.BaseAPI {
    /**
     * Get UEFA API call templates
     */
    async getUefaApiCallTemplatesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        const response = await this.request({
            path: `/uefa/templates`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => (0, models_1.UefaApiTemplateResultFromJSON)(jsonValue));
    }
    /**
     * Get UEFA API call templates
     */
    async getUefaApiCallTemplates(initOverrides) {
        const response = await this.getUefaApiCallTemplatesRaw(initOverrides);
        return await response.value();
    }
}
exports.DEVELOPMENTONLYApi = DEVELOPMENTONLYApi;
